import React, { Component } from 'react'
import { ANALYTICS_CATEGORY } from '../constants/Constants'

class ExpressDealsBanner extends Component {
  handleCTAClick (event) {
    try {
      this.props.onCTAClick(event)
    } catch (error) {}
  }
  // render
  render () {
    const content = this.props.content || {}
    const mobileClass = this.props.showMobileClass || ''

    return (
      <div className={`banner ${mobileClass}`}>
        <div className='content'>
          <div
            className='title'
            dangerouslySetInnerHTML={{ __html: content.title }}
          />
          <div className='text'>{content.body}</div>
        </div>
        <div className='cta'>
          <a
            href={content.href}
            className='primary blue outline'
            onClick={this.handleCTAClick.bind(this)}
            data-ga-category={ANALYTICS_CATEGORY}
            data-ga-action={content.trackingType}
            data-ga-label={content.trackingLabel}
          >
            {content.link}
          </a>
        </div>
      </div>
    )
  }
}

export default ExpressDealsBanner
